import { useEffect, useState } from 'react';

// Same module-level-singleton shape as `@shared/lib/hooks`' `useDialog`
// (which is About's own dialog toggle, not a generic one despite the
// name) -- this is Install's equivalent, kept in this feature rather than
// generalizing that one, since the two dialogs have nothing to do with
// each other beyond both being singletons. Mounting `InstallationDialog`
// once at the app root (`app/app.tsx`, alongside `<About/>`) and toggling
// it from here is what lets both `AppMenu`'s Install entry and the issue
// reader's `IssueButton.Install` open the same dialog without either one
// mounting its own copy or threading `show`/`setShow` down through props.
let dialogState = false;
let listeners: Array<(state: boolean) => void> = [];

export function useInstallDialog(): UseInstallDialogResult {
	const [show, setShow] = useState(dialogState);

	// An effect, not a `useState` initializer: React never calls a function
	// returned from an initializer, so the listener used to stay registered
	// after unmount -- one more per mount (the issue reader mounts this on
	// every visit), each holding its unmounted component alive.
	useEffect(() => {
		const listener = (next: boolean) => setShow(next);
		listeners.push(listener);
		// Catch a change made between this render and the effect running.
		setShow(dialogState);
		return () => {
			listeners = listeners.filter((l) => l !== listener);
		};
	}, []);

	const setShowInstallation = (next: boolean) => {
		dialogState = next;
		listeners.forEach((listener) => listener(next));
	};

	return { show, setShowInstallation };
}

interface UseInstallDialogResult {
	show: boolean;
	setShowInstallation: (value: boolean) => void;
}
